// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

/**
 * Kind of historical read to perform.
 */
export enum HistoryReadKind {
  Raw = 0,
  Modified = 1,
  Processed = 2,
  AtTime = 3,
  Events = 4,
}
